<template>
    <!-- Static sidebar for desktop -->
    <div class="hidden md:fixed md:inset-y-0 md:flex md:w-64 md:flex-col">
        <!-- Sidebar component, swap this element with another sidebar if you like -->
        <div class="flex min-h-0 flex-1 flex-col border-r border-gray-200 bg-gray-100 px-3">
            <div class="flex flex-1 flex-col overflow-y-auto pt-2  pb-4">
                <Logo/>
                <nav class="mt-5 flex-1 space-y-1 bg-gray-100  px-2">

                    <SidebarNavItem v-for="item in navigation" :key="item.name" :item="item"/>
                    <SidebarSecondaryLinks
                        :account-navigation="accountNavigation"
                        :secondary-navigation="secondaryNavigation"/>
                </nav>
            </div>
            <SidebarAccount/>
        </div>
    </div>
</template>
<script>
import {Disclosure, DisclosureButton, DisclosurePanel} from '@headlessui/vue';
import SidebarNavItem from '@/Layouts/Legacy/Partials/SidebarNavItem.vue';
import Logo from '@/Layouts/Legacy/Partials/Logo.vue';
import SidebarAccount from '@/Layouts/Legacy/Partials/SidebarAccount.vue';
import {Link} from '@inertiajs/vue3';
import SidebarSecondaryLinks from '@/Layouts/Legacy/Partials/SidebarSecondaryLinks.vue';

export default {
    components: {
        SidebarSecondaryLinks,
        Link,
        SidebarAccount,
        Logo,
        SidebarNavItem,
        Disclosure,
        DisclosureButton,
        DisclosurePanel
    },
    props: {
        navigation: {
            required: true,
            type: Object,
        },
        secondaryNavigation: {
            required: true,
            type: Object,
        },
        accountNavigation: {
            required: true,
            type: Object,
        }
    }
};
</script>
